import React from 'react';

/**
 * ==================================================================================
 * 3. UI PRIMITIVES
 * ==================================================================================
 */

// --- src/components/UI/Card.js ---
const Card = ({ title, action, children, className = '' }) => (
  <div className={`ui-card ${className}`}>
    {(title || action) && (
      <div className="card-header">
        {title && <h3 className="card-title">{title}</h3>}
        {action && <div>{action}</div>}
      </div>
    )}
    <div className="card-body">
      {children}
    </div>
  </div>
);
export default Card;